import { useContext } from "react";
import AppContext from "src/AppContext";

export function useHasAppAccess() {
  const { account } = useContext(AppContext);

  return {
    hasAccess: account?.status === "Active" || account?.role === 'Admin',
    loading: account?.fullName === "loading..."
  };
}